"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inlineMediaQueryMixin = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _styledComponents = require("styled-components");
var _mediaBreakpointMixin = require("./mediaBreakpointMixin");
/** @mixin inlineMediaQueryMixin */
/**
 * Adds support for an inline media query object for the given prop.
 *
 * The inline media query object is a function that maps breakpoint values to a prop value.
 * You can use the `"default"` key to set the prop value that will be used without any media query.
 *
 * Note: The styles will be created in the order in which the keys of the media query object are
 * inserted. For this reason, it's usually best to make sure `"default"` comes first.
 *
 * @see {@link mediaBreakpointMixin}
 *
 * @example
 * import { css } from 'styled-components';
 * import { mediaQueryMixin } from '@zillow/constellation';
 *
 * const colorCSS = mediaProps => css`
 *     color: ${mediaProps.color};
 * `;
 *
 * const Component = styled.div`
 *     ${inlineMediaQueryMixin('color', colorCSS)}
 * `;
 *
 * <Component color={{ default: 'red', md_lte: 'blue' }}>
 *    Component with colors
 * </Component>
 *
 * @method
 * @param {string} prop - The prop name which will support an inline media query object.
 * @param {function|CSSObject} styles - The styles to be applied at the given breakpoint.
 *     While this can be a simple CSSObject, it should usually be a function that takes
 *     `mediaProps` as the only argument and returns a CSSObject.
 */
var inlineMediaQueryMixin = function inlineMediaQueryMixin(prop, styles) {
  return function (props) {
    var val = props[prop];
    if (typeof val === 'undefined') {
      return '';
    }

    // Handle inline media queries
    if ((0, _typeof2.default)(val) === 'object' && val !== null && !Array.isArray(val)) {
      var mediaStyles = [];
      Object.keys(val).forEach(function (breakpoint) {
        var _Object$assign;
        var mediaProps = Object.assign({}, props, (_Object$assign = {}, _Object$assign[prop] = val[breakpoint], _Object$assign));
        if (breakpoint === 'default') {
          mediaStyles.push(typeof styles === 'function' ? styles(mediaProps) : styles);
        } else {
          mediaStyles.push((0, _styledComponents.css)(["@media ", "{", "}"], (0, _mediaBreakpointMixin.mediaBreakpointMixin)(breakpoint), typeof styles === 'function' ? styles(mediaProps) : styles));
        }
      });
      return mediaStyles;
    }

    // If there is no inline media query, just use the style directly
    return typeof styles === 'function' ? styles(props) : styles;
  };
};
exports.inlineMediaQueryMixin = inlineMediaQueryMixin;